import { render, staticRenderFns } from "./SlideResumeSection.vue?vue&type=template&id=0c833736"
import script from "./SlideResumeSection.vue?vue&type=script&lang=js"
export * from "./SlideResumeSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c833736')) {
      api.createRecord('0c833736', component.options)
    } else {
      api.reload('0c833736', component.options)
    }
    module.hot.accept("./SlideResumeSection.vue?vue&type=template&id=0c833736", function () {
      api.rerender('0c833736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting/SlideResumeSection.vue"
export default component.exports